module.exports = new __parcel__URL__("BrandIcons.82ac0f69.svg").toString();